import { defineComponent as o, createBlock as r, openBlock as n, unref as a, mergeProps as c, withCtx as p, createElementVNode as f } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const u = /* @__PURE__ */ o({
  name: "IconStarHalf",
  __name: "IconStarHalf",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(l) {
    const t = l;
    return (m, e) => (n(), r(a(i), c(t, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        f("path", {
          "fill-rule": "evenodd",
          d: "M13.154 3.65c-.427-1.026-1.881-1.026-2.308 0L8.838 8.478l-5.21.418C2.519 8.984 2.07 10.367 2.914 11.09l3.97 3.4-1.213 5.085a1.231 1.231 0 0 0 .464 1.289l-.013.055.048-.03a1.231 1.231 0 0 0 1.369.043l4.46-2.724 4.462 2.724c.949.58 2.125-.275 1.867-1.357l-1.212-5.084 3.97-3.4c.844-.724.394-2.107-.714-2.196l-5.21-.418-2.008-4.826M12 16.666a1.248 1.248 0 0 1 .652.183l4.078 2.49-1.109-4.648a1.25 1.25 0 0 1 .403-1.24l3.63-3.108-4.765-.382a1.25 1.25 0 0 1-1.054-.766L12 4.782v11.883",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
